<template>
    <el-dialog
        ref="batchViewFileDialog"
        top="8%"
        width="78%"
        title="附件查看"
        :before-close="handleClose"
        :visible="true"
        :close-on-click-modal="false"
    >
        <virtual-table
            ref="virtualTable"
            :loading="loading"
            :columns="tableConfig.table.columns"
            :height="tableConfig.table.height"
            :size="tableConfig.table.size"
            :actions="tableConfig.table.action"
            :selection="tableConfig.table.selection"
            :rows="tableData"
            @btnClick="clickButton"
            @selection-change="selectionChange"
        ></virtual-table>

        <imgShowDialog
            title="图片预览"
            :imgArr="currentRow"
            :fileIndex="fileIndex"
            :attachmentShow.sync="attachmentShow"
            v-if="attachmentShow"
            @handleClose="closeDialog($event)"
        ></imgShowDialog>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleDownload" :disabled="!selectedData.length">下 载</el-button>
            <el-button type="primary" @click="handleDelete" :disabled="!selectedData.length">删 除</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { tableConfig } from './config.js';
import { confirmTip } from '../../util.js';
import { dictWithUrl } from '@/components/lots/api.js';
import { deletePictureByIds, batchAttachmentPreview } from '@/modules/transport/otp/api/performanceReceiptSign.js';
const { PIC_TYPES } = tableConfig.OBJECT_CONST;

export default {
    name: 'batchViewFile',
    components: {
        imgShowDialog: () => import('./imgShow.vue'),
        virtualTable: () => import('./table.vue')
    },
    props: {
        taskNoList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            tableConfig,
            tableData: [],
            currentRow: [],
            selectedData: [],
            fileIndex: 0,
            attachmentShow: false,
            loading: false,
            dictData: {}
        };
    },
    async mounted () {
        await this.getDictData();
        this.getTableData();
    },
    methods: {
        getDictData () {
            return dictWithUrl('SYS_TMS_UPLOAD_WAY,TMS_AI_RESULT').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data || {};
                }
            });
        },
        getTableData () {
            this.loading = true;
            batchAttachmentPreview(this.taskNoList).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = this.formateData(res.data || []);
                    this.currentRow = res.data || [];
                    this.batchViewFile = true;
                }
            }).finally(() => { this.loading = false; });
        },
        clickButton (rowData, prop, row) {
            if (prop === 'view') {
                this.fileIndex = row.$rowIndex;
                this.attachmentShow = true;
            }
        },
        selectionChange (data) {
            this.selectedData = data;
        },
        handleDelete () {
            const param = this.selectedData.map(item => {
                return item.id;
            });
            confirmTip(`此操作将删除选中数据，是否继续?`, deletePictureByIds, param, '删除成功', this, 'getTableData');
        },
        getFileExt (fileName) {
            return fileName && fileName.replace(/^.*\./, '').toLowerCase();
        },
        handleDownload () {
            if (this.selectedData.length > 20) {
                return this.$message.warning('一次最多支持下载不超过20个文件');
            }
            for (let i = 0; i < this.selectedData.length; i++) {
                this.fileDownLoad(this.selectedData[i]);
            }
        },
        fileDownLoad (file) {
            if (PIC_TYPES.includes(this.getFileExt(file.name))) {
                this.downImg(file);
            } else {
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.style.height = 0;
                iframe.src = file.path;
                document.body.appendChild(iframe);
                setTimeout(() => {
                    iframe.remove();
                }, 2 * 60 * 1000);
            }
        },
        downImg (file) {
            var canvas = document.createElement('canvas');
            var img = document.createElement('img');
            img.onload = function (e) {
                canvas.width = img.width;
                canvas.height = img.height;
                var context = canvas.getContext('2d');
                context.drawImage(img, 0, 0, img.width, img.height);
                canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
                canvas.toBlob((blob) => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = file.name;
                    link.click();
                }, 'image/jpeg');
            };
            img.setAttribute('crossOrigin', 'Anonymous');
            img.src = file.path;
        },
        formateData (list) {
            list.forEach(item => {
                item.fileSourceName = this.dictData.SYS_TMS_UPLOAD_WAY[item.fileSource] || '';
                item.aiResultName = item.aiResult ? this.dictData.TMS_AI_RESULT[item.aiResult] : '';
                item.abnormalAiResultName = item.abnormalAiResult ? this.dictData.TMS_AI_RESULT[item.abnormalAiResult] : '';
                item.view = '点我预览';
            });
            return list;
        },
        handleClose () {
            this.$emit('update:batchViewFile', false);
        },
        closeDialog (dialogName) {
            this[dialogName] = false;
        }
    }
};
</script>
